const serverUrl = 'https://radiancediagnostics_api.ocllis.com/';

export const environment = {
    production: true,
  aiEnabled: false,
    cryptoPassphrase: '42b9b632-b845-4f0c-8c2f-ab886466da8c',
    frontendUrl: 'https://radiance-dx.ocllis.com/',
    fusionAuth: {
        apiUrl: 'https://authprovider.ocllis.com/api',
        applicationId: '42b9b632-b845-4f0c-8c2f-ab886466da8c',
        apiKey: 'byH58HluJNiaPKxreXAiVeXD62FTjpdXBJtnXcJ90rk',
        tenantId: '424a96cd-f65d-4fd5-b371-10ecc5f02393'
    },
    portalBackend: {
        serverUrl,
        apiUrl: `${serverUrl}api`,
    },
  aiAnalysis: {
    enabled: false,
    apiUrl: 'https://portal-analyzer.ocllis.com',
    enabledRoles: ['*']
  },
  aiCommands: {
    enabled: false,
    areas: ['missing-info'],
    apiUrl: 'https://portal-voice-analyzer.ocllis.com'
  },
  resultExport: true,
    sentry: {
        dns: 'https://712927c1f6ae4392acffa3bd00de235c@o506030.ingest.sentry.io/5595302',
    },
  allowCreateRequisitionWithMissingBillingInfo: true,
  allowCreateRequisitionWithMissingDiagnoses: true,
  allowCreateRequisitionWithMissingSignature: true,
  alternativeRequisitionForm: false,
};
